import { useCallback } from 'react';
import { useLazyQuery, gql } from '@apollo/react-hooks';
import { getAssetPlanScopeSummary } from '#/graphql/queries';
import type {
  GetAssetPlanScopeSummaryQuery,
  GetAssetPlanScopeSummaryQueryVariables,
} from '#/graphql/types';

const q = gql(getAssetPlanScopeSummary);

const useAssetPlanScopeSummaryLazyQuery = (
  variables: GetAssetPlanScopeSummaryQueryVariables = {},
) => {
  const [executeFetch] = useLazyQuery<
    GetAssetPlanScopeSummaryQuery,
    GetAssetPlanScopeSummaryQueryVariables
  >(q, {
    variables,
    fetchPolicy: 'network-only',
  });

  const fetchAssetPlanScopeSummary = useCallback(
    async (options?: Parameters<typeof executeFetch>[0]) => {
      const result = await executeFetch(options);
      return result.data?.getAssetPlanScopeSummary?.data ?? null;
    },
    [executeFetch],
  );

  return fetchAssetPlanScopeSummary;
};

export default useAssetPlanScopeSummaryLazyQuery;
